import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
// import { RootState } from '../../store'
import type {
  InvitationResponse,
  InvitationRequest,
  LoginRequest,
  LoginResponse,
  SignUpRequest,
  SignUpResponse,
} from "../auth/types";

const baseUrl =
  process.env.REACT_APP_SERVER_ENV === "LOCAL"
    ? "http://localhost:19001/api"
    : process.env.NODE_ENV === "development"
      ? "/api"
      : "https://fitshapeapp.work/api";
// Define a service using a base URL and expected endpoints

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const userJwt = window.localStorage.getItem("userJwt");
    //(getState() as RootState).user.jwtToken
    if (userJwt) {
      headers.set("Authorization", `Bearer ${userJwt}`);
    }
    return headers;
  },
});
const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (
    result.error &&
    // @ts-ignore
    (result.error.status === 401 || result.error.originalStatus === 401)
  ) {
    window.localStorage.removeItem("userJwt");
    window.location.href = "/login";
  }
  return result;
};
export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "Users",
    "Booking",
    "User",
    "History",
    "Exercises",
    "Workouts",
    "WorkoutHistory",
    "Diet",
    "Workout",
    "Progressions",
    "ProgressionContainers",
    "WorkoutContainers",
    "ExerciseContainers",
    "SpecialCategories",
  ],
  baseQuery: baseQueryWithReauth,

  endpoints: (builder) => ({
    validateInvitation: builder.query<InvitationResponse, InvitationRequest>({
      query: ({ token }) => `/invitation/${token}`,
    }),
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (loginReq) => ({
        url: "/user/login",
        method: "POST",
        body: loginReq,
      }),
    }),
    signUp: builder.mutation<SignUpResponse, SignUpRequest>({
      query: (signUpReq) => ({
        url: "/signup",
        method: "POST",
        body: signUpReq,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyValidateInvitationQuery,
  useLoginMutation,
  useSignUpMutation,
} = api;
